<script setup lang="ts">
import { computed } from 'vue'
import { useGlobalSearch } from '@/widgets/GlobalSearch'
import { VIcons } from '@/shared/ui'

const model = useGlobalSearch()

const coords = computed(() => model.query.area?.center ?? model.query.area?.bbox ?? [])
const coordsText = computed(() => coords.value.join(', '))
const isCircleArea = computed(() => model.query.area?.type === 'circle')

const formattedCoords = computed(() =>
  coords.value.map((item) => `${item.toFixed(5)}...`).join(', '),
)

/**
 * Функция удаления выбранных координат
 */
const deleteHandler = () => {
  model.query.area = null
}
</script>

<template>
  <div v-if="model.query.area">
    <VDivider class="my-4" />

    <div class="w-global-search__coords">
      <p>{{ $t('itf.from_coords') }}:</p>

      <VTooltip location="top" :text="coordsText">
        <template #activator="{ props }">
          <p v-bind="props" class="w-global-search__coords-value">
            {{ formattedCoords }}
          </p>
        </template>
      </VTooltip>

      <div>
        <VTextField
          v-if="isCircleArea"
          :label="$t('itf.radius')"
          v-model="model.query.area.radius"
          hide-details
        />
      </div>

      <VBtn color="error" variant="tonal" @click="deleteHandler">
        <VIcons type="archive" />
      </VBtn>
    </div>
  </div>
</template>
